import type { FooterItem } from './types';

const PRIVACY_PORTAL_URL =
  'https://app.privasee.io/privacy-portal/64ac2c059f43880013f2faf0';

const DE_LINKS: FooterItem[] = [
  { link: '/terms-and-conditions/', name: 'AGB' },
  { external: true, link: PRIVACY_PORTAL_URL, name: 'Datenschutz' },
  { link: '/about/', name: 'Über uns' }
];

const MARKETPLACE_LINKS = {
  DE: DE_LINKS,
  GB: [
    { link: '/terms-and-conditions/', name: 'Terms' },
    { link: '/terms-and-conditions/sellers/', name: 'Seller terms' },
    { external: true, link: PRIVACY_PORTAL_URL, name: 'Privacy' },
    { link: '/about/', name: 'About' },
    { link: '/contact/', name: 'Contact' },
    { link: '/about/#editorial-policy', name: 'Editorial policy' }
  ]
};

const LEGAL_LINKS = {
  DE: DE_LINKS,
  GB: [
    { link: '/terms-and-conditions/', name: 'Terms' },
    { link: '/terms-and-conditions/sellers/', name: 'Seller terms' },
    { external: true, link: PRIVACY_PORTAL_URL, name: 'Privacy' },
    { link: '/about/#editorial-policy', name: 'Editorial policy' }
  ]
};

export const DISCOVER_LINKS: FooterItem[] = [
  { link: '/release-dates/', name: 'Footwear' },
  { link: '/sole-market/', name: 'Marketplace' },
  { link: '/release-dates/?sort=SALE', name: 'Sale' },
  { link: '/clothing/', name: 'Clothing' },
  { link: '/news/', name: 'News' },
  { link: '/profile/', name: 'Profile' }
];

export const GET_IN_TOUCH_LINKS: FooterItem[] = [
  { link: '/about/', name: 'About' },
  { link: '/contact/', name: 'Contact us' }
];

export function getMenu(regionCode: string): FooterItem[] {
  return (
    MARKETPLACE_LINKS[regionCode as keyof typeof MARKETPLACE_LINKS] ??
    MARKETPLACE_LINKS.GB
  );
}

export function getLegalLinks(regionCode: string): FooterItem[] {
  return LEGAL_LINKS[regionCode as keyof typeof LEGAL_LINKS] ?? LEGAL_LINKS.GB;
}
